import { TokenService } from "../services/token.service";
import { Injectable } from "@angular/core";
import { ToastrAlertService } from "../services/toastrAlert.service";
import { TranslateService } from "@ngx-translate/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class LoginGuard implements CanActivate {
  constructor(
    private tokenService: TokenService,
    private router: Router,
    private toastrAlertService: ToastrAlertService,
    private translateService: TranslateService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (!this.tokenService.isLogged()) {
      this.translateService.get("messages.NotLoggedIn").subscribe(
        (data) => {
          let message = data;
          this.toastrAlertService.toastrFail(message);
          this.router.navigate(["/login"]);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
      return false;
    }
    return true;
  }
}
